import { useState, useEffect } from "react";

const useTaskKey = (taskTypeName) => {
  const [key, setKey] = useState("");

  useEffect(() => {
    if (taskTypeName) {
      const words = taskTypeName.trim().split(" ");

      let generatedKey = words
        ?.filter((word) => !!word)
        .map((word) => word[0].toUpperCase())
        .join("");

      if (generatedKey.length > 3) {
        generatedKey = generatedKey.slice(0, 3);
      }

      if (generatedKey.length < 3) {
        // const rightCount = (3 - generatedKey.length+1);
        // if(words[words.length-1].length >= rightCount)
        //   generatedKey += words[words.length-1].slice(1, rightCount);
        // else
        generatedKey = generatedKey.padEnd(3, "_");
      }
      setKey(generatedKey);
    } else if (key !== "") {
      setKey("");
    }
  }, [taskTypeName]);

  return key;
};

export default useTaskKey;
